module.exports = __webpack_public_path__ + "assets/TB_Android_Large_Checkmark_Icon.svg";